import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const DropdownContainer = styled.div`
  width: 100%;
  position: relative;
`;

const DropdownHeader = styled.div`
  padding: 9px;
  line-height: 18px;
  border: 1px solid ${({ hasError }) => (hasError ? "#f44336" : "#ccc")};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DropdownListContainer = styled.div`
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1000;
  background-color: white;
`;

const DropdownList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  padding: 9px;
  line-height: 18px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const Checkbox = styled.input`
  margin-right: 10px;
`;

const Caret = styled.span`
  border: solid black;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  padding: 3px;
  transform: ${({ isOpen }) => (isOpen ? "rotate(-135deg)" : "rotate(45deg)")};
  transition: transform 0.2s ease;
`;

const MultiSelectDropdown = ({
  options,
  selectVal = [],
  onSelectionChange,
  error,
  showDLR,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    selectVal && selectVal.length > 0 ? selectVal.map((opt) => opt.value ? opt.value : opt) : []
  );
  const dropdownRef = useRef(null);
  const previousSelectedOptionsRef = useRef([]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    if (option === "Select All") {
      if (selectedOptions.length === options.length) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions(options.map((opt) => opt.value));
      }
    } else {
      // remove 'At Risk' from selectedOptions if it is not shown in the dropdown if dlr flag is off
      for(let key in selectedOptions)
        {
          if(!showDLR && selectedOptions[key] == 'At Risk'){
            selectedOptions.splice(key, 1);                 
          }
         
        }
      setSelectedOptions((prevSelected) =>
        prevSelected.includes(option)
          ? prevSelected.filter((o) => o !== option)
          : [...prevSelected, option]
      );
    }
  };

  useEffect(() => {
    if (
      selectedOptions.length === options.length &&
      selectedOptions.includes("Select All")
    ) {
      setSelectedOptions(options.map((opt) => opt.value));
    }
    if (selectedOptions.length == 1 && selectedOptions.includes("Select All")) {
      setSelectedOptions(options.map((opt) => opt.value));
    } else if (
      selectedOptions.length < options.length &&
      selectedOptions.includes("Select All")
    ) {
      setSelectedOptions(selectedOptions.filter((opt) => opt !== "Select All"));
    } else {
        // do nothing
    }
  }, [/*selectedOptions,*/ options]);

  useEffect(() => {
    if (
      JSON.stringify(selectedOptions) !==
      JSON.stringify(previousSelectedOptionsRef.current)
    ) {
      onSelectionChange(selectedOptions);
      previousSelectedOptionsRef.current = selectedOptions;
    }
  }, [selectedOptions, onSelectionChange]);

  const renderSelectedValues = () => {
    if (selectedOptions.length === 0) return "Select Options";
    if (selectedOptions.length === options.length) return "Select All";
    const firstOption = selectedOptions[0];
    const remainingCount = selectedOptions.length - 1;
    return remainingCount > 0
      ? `${firstOption} +${remainingCount}`
      : firstOption;
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //const hasError = selectedOptions.length === 0 || error;

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownHeader onClick={toggleDropdown} hasError={error}>
        {renderSelectedValues()}
        <Caret isOpen={isOpen} />
      </DropdownHeader>
      {isOpen && (
        <DropdownListContainer>
          <DropdownList>
            {options.map((option) => (
              option.value == "At Risk" && !showDLR ? null : (
                <ListItem
                  key={option.value}
                  onClick={() => handleOptionClick(option.value)}
                >
                  <Checkbox
                    type="checkbox"
                    checked={selectedOptions.includes(option.value)}
                    readOnly
                  />
                  {option.label}
                </ListItem>
              )
            ))}
          </DropdownList>
        </DropdownListContainer>
      )}
    </DropdownContainer>
  );
};

export default MultiSelectDropdown;
